import { createEvent, getAllEvents, getEventById, updateEvent } from 'api/admin/event';
import { getAllEvents as getAllEventsByCustomer, createEvent as createEventByCustomer , getMyEvents} from 'api/customer/event'
import { useSnackbar } from 'notistack';
import { useMutation, useQuery, useQueryClient } from 'react-query';

function useCreateEvent() {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation(createEvent, {
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onSuccess: () => {
      queryClient.invalidateQueries('events');
      enqueueSnackbar('عملیات با موفقیت انجام شد.', { variant: 'success' });
    },
  });
}

function useCreateEventByCustomer() {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation(createEventByCustomer, {
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onSuccess: () => {
      queryClient.invalidateQueries('events');
      enqueueSnackbar('نوبت شما برای ۱۵ دقیقه رزرو شد. در حال انتقال به درگاه پرداخت... ', { variant: 'success' });
    },
  });
}

function useAllEvents(dId, options) {
  return useQuery(['events', dId], () => getAllEvents(dId), { ...options });
}

// function useAllEventsByCustomer(personnelId, options) {
//   return useQuery(['events', personnelId], () => getAllEventsByCustomer(personnelId), { ...options });
// }

function useAllEventsByCustomer(limit, page) {
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation(
    ({serviceId,from,to}) => getAllEventsByCustomer({serviceId,from,to}),
    {
      onError: (err) => {
        enqueueSnackbar(
          err.response && err.response.data.message ? err.response.data.message : err.message,
          { variant: 'error' }
        );
      },
      onSuccess: () => {
      },
    }
  )

  return mutation;
}

function useMyEvents(limit, page) {
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation(
    () => getMyEvents(),
    {
      onError: (err) => {
        enqueueSnackbar(
          err.response && err.response.data.message ? err.response.data.message : err.message,
          { variant: 'error' }
        );
      },
      onSuccess: () => {
      },
    }
  )
  return mutation;
}


function useEvent(id, options) {
  return useQuery(['event', id], () => getEventById(id), { ...options });
}

function useUpdateEvent() {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  return useMutation(updateEvent, {
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onSuccess: (_) => {
      queryClient.invalidateQueries();
      enqueueSnackbar('نوبت با موفقیت ویرایش شد', { variant: 'success' });
    },
  });
}

export { useCreateEvent, useAllEvents, useEvent, useUpdateEvent, useAllEventsByCustomer, useCreateEventByCustomer, useMyEvents };
